import React , { useState, useEffect, useRef, useCallback } from "react";
import tw, { styled, css, theme } from 'twin.macro'
import { QRCode, Close } from "ffxiv-fanfest-2024";
import { useLocalization } from "gatsby-theme-i18n";
import { useCookies } from 'react-cookie';


type QRCodeSectionProps = {
  uri : string
}


export default function QRCodeSection({uri} : QRCodeSectionProps) {
  const { t }  = useLocalization();
  const [cookies, setCookie] = useCookies(['qrcodeShowed']);

  const MouseoverTimer = useRef(null);

  const [ isActive, setIsActive ]  = useState(typeof cookies['qrcodeShowed'] === "undefined" || cookies['qrcodeShowed'] !== "true");
  const [ isAnimated, setIsAnimated ]  = useState(false);

  useEffect(() => {
    if(typeof cookies['qrcodeShowed'] === "undefined")
    {
      MouseoverTimer.current = setTimeout(closeQrcode, 15000);
    }
  },[]);


  const closeQrcode = useCallback(() => {
    setIsActive(false)
    setCookie('qrcodeShowed', 'true', { path: '/' });
  },[]);


  useEffect(() => {
    if(isActive && !isAnimated)
    {
      setTimeout(() => {
        setIsAnimated(true);
      },400);
    } else if (!isActive && isAnimated)
    {
      setIsAnimated(false);
    }
  },[isActive, isAnimated]);

  return (
    <QRCodeSectionWrapper className={`${isActive ? `active` : ``}${isAnimated ? ` animated` : ``}`} onMouseEnter={() => {
      clearTimeout(MouseoverTimer.current);
    }} onMouseLeave={() => {
      MouseoverTimer.current = setTimeout(closeQrcode, 15000);
    }}>
      <a href="#" className="btnShow" onClick={(e) => {
          e.preventDefault();
          setIsActive(true);
        }}>
        <QRCode title={t('common_qrcode.qrcode.button.show.label')}/>
      </a>
      <a href="#" className="btnClose" onClick={(e) => {
          e.preventDefault();
          closeQrcode();
        }}>
        <Close title={t('common_qrcode.qrcode.button.hide.label')}/>
      </a>
      <img src={uri} />
      <p>{t('common_qrcode.qrcode.annotation')}</p>
    </QRCodeSectionWrapper>
  )
}


const QRCodeSectionWrapper = styled.div`
  ${tw`
    fixed
    z-[100]
    left-8
    bottom-8
    bg-livid-50
    shadow-[0px 0px 96px -32px rgba(0, 0, 0, 0.06), 0px 32px 96px -32px rgba(0, 0, 0, 0.12), 0px 32px 64px -32px rgba(0, 0, 0, 0.16)]
    p-8
    rounded-[32px 9px]

    w-[80px]
    h-[80px]
    box-border

    transition-[width,height]
    duration-[400ms]

  `}

  img{
    ${tw`
      w-[160px]
      mb-4
      opacity-0
      transition-opacity
      hidden
    `}
  }
  p{
    ${tw`
      text-[14px]
      leading-[20px]
      opacity-0
      transition-opacity
      hidden
    `}
  }
  .btnClose{
    ${tw`
      absolute
      top-0
      right-0
      p-1
      text-[24px]
      text-livid-500
      hover:text-livid-900
      active:text-fanfes-light-800
      opacity-0
      transition-opacity
      hidden
    `}
  }
  .btnShow{
    ${tw`
      block
      absolute
      top-[50%]
      left-[50%]
      translate-x-[-50%]
      translate-y-[-50%]
      p-[6px]
      text-[36px]
      text-livid-700
      hover:text-livid-900
      active:text-livid-800
      opacity-100
      transition-opacity
      z-10
    `}
  }


  &.active{
    ${tw`
      w-[224px]
      h-[280px]
    `}
    img, p, .btnClose{
      ${tw`
        block
      `}
    }

    .btnShow{
      ${tw`
        opacity-0
      `}
    }
  }

  &.animated{
    img, p, .btnClose{
      ${tw`
        opacity-100
      `}
    }
    .btnShow{
      ${tw`
        hidden
      `}
    }
  }
`
